class ExtendHelper {
    constructor(){
        this.extensionMap = new Map();
        this.appliedExtensions = new Set();
    }
    static getInstance() {
        if (!ExtendHelper.instance) ExtendHelper.instance = new ExtendHelper();
        return ExtendHelper.instance;
    }
    extend(className, extenderFunction) {
        const key = className;
        if (!this.extensionMap.has(key)) this.extensionMap.set(key, []);
        this.extensionMap.get(key).push(extenderFunction);
        return this;
    }
    applyExtensions(originalClass) {
        const className = originalClass.name;
        const extensions = this.extensionMap.get(className) || [];
        if (0 === extensions.length) return originalClass;
        if (this.appliedExtensions.has(className)) return originalClass;
        let ExtendedClass = originalClass;
        extensions.forEach((extenderFn)=>{
            ExtendedClass = extenderFn(ExtendedClass);
        });
        this.appliedExtensions.add(className);
        this.copyMetadata(originalClass, ExtendedClass);
        return ExtendedClass;
    }
    copyMetadata(originalClass, extendedClass) {
        if (originalClass.prototype?.metadata) extendedClass.prototype.metadata = originalClass.prototype.metadata;
        const metadataKeys = [
            '__autoRegister__',
            '__injectable__',
            '__singleton__',
            '__paramTypes__',
            '__injectedTokens__',
            '__optionalParams__',
            '__injectedProperties__',
            '__optionalProperties__'
        ];
        metadataKeys.forEach((key)=>{
            if (void 0 !== originalClass[key]) extendedClass[key] = originalClass[key];
        });
        if ('undefined' != typeof Reflect && Reflect.getMetadata) {
            const metadataKeys = Reflect.getMetadataKeys?.(originalClass) || [];
            metadataKeys.forEach((key)=>{
                const metadata = Reflect.getMetadata(key, originalClass);
                if (void 0 !== metadata) Reflect.defineMetadata(key, metadata, extendedClass);
            });
        }
    }
    hasExtensions(className) {
        return this.extensionMap.has(className) && this.extensionMap.get(className).length > 0;
    }
    getExtensions() {
        return new Map(this.extensionMap);
    }
    clear() {
        this.extensionMap.clear();
        this.appliedExtensions.clear();
    }
    clearExtensions(className) {
        this.extensionMap.delete(className);
        this.appliedExtensions.delete(className);
    }
}
function setupGlobalExtensions(globalObject = 'undefined' != typeof window ? window : globalThis) {
    const helper = ExtendHelper.getInstance();
    if (!globalObject.boostWidgetIntegration) globalObject.boostWidgetIntegration = {};
    globalObject.boostWidgetIntegration.extend = helper.extend.bind(helper);
    return helper;
}
export { ExtendHelper, setupGlobalExtensions };
